import { httpClient } from '@/shared/services/http-client'
import { loadingService } from '@/shared/services/loading-service'

export const dashboardState = {
  namespaced: true,
  state: {
    dashboardJsonData: null
  },
  mutations: {
    setDashboardData(state, data) {
      state.dashboardJsonData = data;
    }
  },
  actions: {
    async getDashboardJsonData(context, schoolId) {
      const url = `dashboard`;
      loadingService.showLoading(true);
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              basicMetrics(id: $id){
                studentTeacherRatio
                studentNonTeacherRatio
                recurrentIncomePerStudent
              } 
              basicYearlyInfo(id:$id){
                calendarYear
                totalEnrolments
                fullTimeEquivalentEnrolments
                fullTimeEquivalentTeachingStaff
                fullTimeEquivalentNonTeachingStaff
                teachingStaff
                nonTeachingStaff
                girlsEnrolments
                boysEnrolments
                indigenousEnrolmentsPercent
                enrolmentsPerStaff
                enrolmentsPerTeacher
                enrolmentsPerNonTeacher
                enrolmentsPerStaffFullTimeEquivalent
                enrolmentsPerTeacherFullTimeEquivalent
                enrolmentsPerNonTeacherFullTimeEquivalent
                icsea
                bottomSeaQuarterPercent
                lowerMiddleSeaQuarterPercent
                upperMiddleSeaQuarterPercent
                topSeaQuarterPercent
              }
              finance(id:$id){
                calendarYear
                incomeTotalNetRecurrent
                incomeFeesChargesParent
                incomeAusRecurrent
                incomeStateRecurrent
                incomeOtherPrivate
                capitalExpendAus
                capitalExpendState
                capitalExpendTotal
                FTEFundedEnrolments
                incomeAusRecurrentPerStudent
                incomeStateRecurrentPerStudent
                incomeOtherPrivatePerStudent
                incomeTotalGrossPerStudent
                incomeTotalNetRecurrentPerStudent
              }
              secondaryOutcome(id:$id){
                calendarYear
                seniorSecondaryCertificatesAwarded
                completedSeniorSecondarySchool
              }
              attendance(id:$id){
                calendarYear
                attendanceLevel
                attendanceRate
                indigenousAttendanceLevel
                indigenousAttendanceRate
                nonIndigenousAttendanceLevel
                nonindigenousAttendanceRate
              }
              postSchoolDestination(id:$id){
                calendarYear
                studentsAtUniversity
                studentsAtTafe
                studentsInEmployment
              }
              studentEnrolPresent(id:$id){
                student
                entryDate
                leaveDate
                gender
              }
              financialIncomeStatement(id:$id){
                year
                month
                amount
                budget
                amountType
              }
              enrolmentsByGrade(id:$id){
                calendarYear
                year1Enrolments
                year2Enrolments
                year3Enrolments
                year4Enrolments
                year5Enrolments
                year6Enrolments
                year7Enrolments
                year8Enrolments
                year9Enrolments
                year10Enrolments
                year11Enrolments
                year12Enrolments
                primaryUngradedEnrolments
                secondaryUngradedEnrolments
              }
            }
          }
        `,
        variables: { 'id': schoolId }
      };

      const dashboardJson = await httpClient.post(url, body)
        .then(res => {
          const data = res.data;

          if (data.data != null && data.data != undefined) {
            context.commit('setDashboardData', data.data)
          }
          else {
            console.log("dashboardJson [\"data\"][\"data\"] is undefined ")
            console.log(data)
          }
        })
        .catch(err => {
          console.log(err);
          throw err;
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async getDashboardEnrolmentMetricJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              enrolmentMetrics(id: $id){
                enrolmentAllMetrics
              }
            
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['enrolmentMetrics']['enrolmentAllMetrics']
        }
        else {
          return []
        }
      })

    },
    async getDashboardFinanceMetricJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              financeMetrics(id: $id){
                financeAllMetrics
              }
            
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['financeMetrics']['financeAllMetrics']
        }
        else {
          return []
        }
      })
    },
    async getDashboardStaffMetricJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              staffMetrics(id: $id){
                staffAllMetrics
              }
            
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['staffMetrics']['staffAllMetrics'];
        }
        else {
          return []
        }
      })
    },
    async getDashboardStudentMetricJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              studentMetrics(id: $id){
                studentAllMetrics
              }
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['studentMetrics']['studentAllMetrics'];
        }
        else {
          return []
        }
      })
    },

    async getDashboardEnrolmentTrendJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              enrolmentTrend(id: $id){
                enrolmentAllTrends
              }
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['enrolmentTrend']['enrolmentAllTrends'];
        }
        else {
          return []
        }
      })

    },
  
    async getDashboardFinanceTrendJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              financeTrend(id: $id){
                financeAllTrends
              }
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['financeTrend']['financeAllTrends'];
        }
        else {
          return []
        }
      })

    },
    
    async getDashboardStaffTrendJsonData(context, schoolId) {
      const body = {
        query: `
          query($id:Int!){
            acaraDashboardQuery{
              staffTrend(id: $id){
                staffAllTrends
              }
            }
          }
        `,
        variables: { 'id': schoolId }
      };
      return await httpClient.post('dashboard', body).then(res => {
        const data = res.data;
        if (data.data != null && data.data != undefined) {
          return data.data['acaraDashboardQuery']['staffTrend']['staffAllTrends'];
        }
        else {
          return []
        }
      })

    }
  }
}
